import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from '../../containers/routes/private-route';
import Login from '../../containers/auth/login';
import Signup from '../../containers/auth/signup';
import ForgotPassword from '../../containers/auth/forgot';
import App from '../app';

const Root = () => (
  <Router>
    <Switch>
      <PrivateRoute exact path="/" component={App} />
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Route path="/forgot" component={ForgotPassword} />
      <Route component={({ location }) => <div>{location.pathname} not found</div>} />
    </Switch>
  </Router>
);

export default Root;



// WEBPACK FOOTER //
// ./src/components/root/index.js